<div class="ag-input-wrapper inner-icon right-icon">
  <i class="far fa-calendar fa-sm" (click)="datePicker.toggle()"></i>
  <input
    class="form-control"
    ngbDatepicker
    #datePicker="ngbDatepicker"
    (click)="datePicker.toggle()"
    (change)="onDateChanged($event.target.value)"
    (dateSelect)="onDatePicked($event)"
  />
</div>
